module.exports = __webpack_public_path__ + "img/uy.79b0285.svg";